import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Color, Size } from '../../../../const'
import _ from 'lodash'

function PageTitle({ title, text, textStyles = { color: Color.FONT.MENU_DARK }, titleStyles = {} }) {
  let TextArea = ''
  const newTextStyles = _.merge(textStyles, { whiteSpace: 'pre-line' })
  if (text !== undefined) {
    TextArea = <TextBlock style={newTextStyles}>{text}</TextBlock>
  }

  return (
    <Wrapper>
      <TitleBlock style={titleStyles}>{title}</TitleBlock>
      {TextArea}
    </Wrapper>
  )
}

const Wrapper = styled.div``
const TitleBlock = styled.div`
  font-size: ${Size.FONT.HEADLINE.LEARGE};
  padding-bottom: 10px;
  font-weight: 700;
`
const TextBlock = styled.div`
  font-size: ${Size.FONT.HEADLINE.MEDIUM};
  padding-bottom: 30px;
  font-weight: 700;
`

PageTitle.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
  textStyles: PropTypes.instanceOf(styled.style),
}

export default PageTitle
